export default [
  {
    path: '/year-books',
    name: 'year-book',
    meta: { requiresAuth: true },
    component: () => import('@/pages/year-book/index.vue')
  }
]
